import { makeRequest, API_URL } from '../Fetch';

export function createPurchase({
  listings, user, amount, rateId, shipmentId, address, token,
}) {
  const payload = {
    user,
    token,
    listings,
    address,
    amount,
    shipmentId,
    rateId,
  };
  return makeRequest(API_URL + 'purchase', payload).send();
}